import React, {useEffect, useState} from 'react';
import * as PropTypes from "prop-types";

/**
 * @description      This is button
 * @return JSX.Element
 * @author          Kerem Karadeniz
 * @param value,
 * @param onChange
 * @param height
 * @param color
 * @param fontWeight
 * @param fontSize
 * @param bgColor  --- Enter a value or any color in the color scheme.
 * @param borderRadius
 * @param border
 * @param minWidth
 * @param disabled
 * @param cursor
 */


const colorScheme = {
    auDarkBlue: "#031226",
    auBlue: "#212F3B",
    auRed: "#D75E5E",
    auGreen: "#5AC384",
}
const Button = ({
                    value,
                    onClick,
                    borderRadius,
                    bgColor,
                    fontWeight,
                    fontSize,
                    minWidth,
                    color = "#fff",
                    height,
                    border,
                    disabled = false,
                    cursor
                }) => {

    const [style, setStyle] = useState({});

    const getBackground = (filterColor) => {
        return filterColor?.length > 0 ? colorScheme[filterColor] : bgColor
    }

    useEffect(() => {
        let filterColor = Object.keys(colorScheme).filter(item => item?.toLowerCase() === bgColor?.toLowerCase());
        setStyle({
            background: bgColor ? getBackground(filterColor) : '#031226',
            borderRadius: borderRadius ? borderRadius : 4,
            color: color,
            minWidth: minWidth ? minWidth : 100,
            height: height ? height : 34,
            fontWeight: fontWeight ? fontWeight : "600",
            fontSize: fontSize ? fontSize : 12,
            border: border ? border : "none",
        })
    }, [])

    return (<div>
        <button
            disabled={disabled}
            onClick={onClick}
            style={{...style, cursor: cursor}}
        >{value}</button>
    </div>);
};

Button.propTypes = {
    value: PropTypes.any,
    onClick: PropTypes.func,
    borderRadius: PropTypes.any,
    bgColor: PropTypes.any,
    fontWeight: PropTypes.any,
    fontSize: PropTypes.any,
    minWidth: PropTypes.any,
    color: PropTypes.any,
    height: PropTypes.any,
    border: PropTypes.any,
    disabled: PropTypes.bool
}

export default Button;
